export default "__VITE_ASSET__5611a52c__"